import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "16",
  fill: "none",
  viewBox: "0 0 18 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m1.3 2.887 3.515 2.324L8.32.348A.84.84 0 0 1 8.999 0a.84.84 0 0 1 .682.348l3.504 4.863L16.7 2.887a.842.842 0 0 1 1.216.33c.07.142.097.301.078.459L16.62 15.267a.83.83 0 0 1-.275.523.84.84 0 0 1-.556.21H2.212a.84.84 0 0 1-.556-.21.83.83 0 0 1-.275-.523L.006 3.675a.82.82 0 0 1 .393-.804.84.84 0 0 1 .901.016M9 11.021c.444 0 .87-.175 1.184-.487a1.653 1.653 0 0 0 0-2.347 1.68 1.68 0 0 0-2.368 0 1.653 1.653 0 0 0 0 2.347c.314.312.74.486 1.184.486"
    }, null, -1)
  ])))
}
export default { render: render }